module.exports = __webpack_public_path__ + "static/media/Strategy-Session-Questionnaire.038b70d5.pdf";